import React, { useState, useEffect } from "react";
import { FormInput, FormSelect, Row, Col, Button } from "shards-react";
import baseUrl from "config/baseUrl";
import useToken from "shared/hook/useToken";
import Loading from "../Loading";

const Table20 = (props) => {
  const { token } = useToken();
  const [loading, setLoading] = useState(false);
  const [PowerbiData, setPowerbiData] = useState(null);
  const [importPath, setImportPath] = useState(null);

  const axios = require("axios").default;

  const getCurrentData = () => {
    setLoading(true);
    let data = JSON.stringify({
      params: {
        indicatorsDatasetSettingId: props.indicatorsDatasetSettingId,
        tableTabSettingId: props.tableTabSettingId || null,
        tableHeadId: props.listheadId || null,
        yearNo: props.newHeadId ? null : Number(props.yearNo),
      },
      show: 1,
      page: 1,
      orderBy: "id",
      orderType: "desc",
    });

    var configData = {
      method: "post",
      url: `${baseUrl}/v1/setting-table/listhead`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: data,
    };
    axios(configData)
      .then(function(response) {
        if (response.data.data.length > 0) {
          setImportPath(response.data.data[0].importPath);
          const dataView = response.data.data[0].list.map((item) => {
            let data = { ...item };
            if (props.type === "new" && props.newHeadId) {
              data.fillValue = "";
              data.growth = "";
            }
            return data;
          });
          setPowerbiData(dataView);
          setLoading(false);
        } else {
          setPowerbiData(null);
          setLoading(false);
        }
      })
      .catch(function(error) {
        setLoading(false);
        console.log(
          `v1/setting-table/listhead ${props.indicatorsDatasetSettingId}`,
          error
        );
      });
  };

  useEffect(() => {
    getCurrentData();
  }, []);

  useEffect(() => {
    getCurrentData();
  }, [props.yearId]);

  return (
    <Row>
      {props.type === "edit" ? (
        <Col md="12" style={{ padding: "15px" }}>
          <h5 style={{ float: "left" }}>
            จำนวนข้อมูลทั้งหมด {PowerbiData != null ? PowerbiData.length : 0}{" "}
            แถว เนื่องจากข้อมูลมีจำนวนมากจึงไม่สามารถแสดงได้
          </h5>
        </Col>
      ) : (
        <Col md="12" style={{ padding: "15px" }}>
          <h3>
            เนื่องจากชุดข้อมูล มีข้อมูลจำนวนมาก กรุณาเพิ่มข้อมูลต่างๆในรูปแบบ
            UPLOAD FILE
          </h3>
        </Col>
      )}

      {props.tableTabMaster
        ? null
        : props.type === "edit" && (
            <Col md="12" style={{ padding: "15px" }}>
              {props.status == 0 && props.userType != 3 ? (
                <>
                  {importPath != null && (
                    <a href={importPath} download >
                      <Button theme="warning" style={{ float: "left" }}>
                        ดาวน์โหลดไฟล์ข้อมูลที่ใช้นำเข้า
                      </Button>
                    </a>
                  )}

                  <Button
                    theme="success"
                    onClick={() => props.onApproveTable()}
                    style={{ float: "right", width: 200 }}
                  >
                    อนุมัติเผยแพร่
                  </Button>
                </>
              ) : null}
            </Col>
          )}
    </Row>
  );
};

export default Table20;
